import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  Root,
  Hero,
  HeroImageContainer,
  HeroContent,
  HeroTitle,
  AccessSection,
  AccessSectionHeader,
  AccessSectionGrid,
  Title,
  Desc,
  Card,
  CardTitle,
  VideosSection,
  VideosGrid,
} from './EducationOnDemand.style';

import { EducationBlock } from '../../../components/EducationBlock/EducationBlock';
import { Button } from '../../../ui/Button/Button';

import { getAcademy, educationalVideos } from './config';

export const EducationOnDemand = () => {
  const intl = useIntl();
  const academy = getAcademy(intl);

  return (
    <Root>
      <Hero>
        <HeroImageContainer />
        <HeroContent>
          <HeroTitle>
            <FormattedMessage defaultMessage="Education On Demand" />
          </HeroTitle>
        </HeroContent>
      </Hero>

      <AccessSection>
        <AccessSectionHeader>
          <Title>
            <FormattedMessage defaultMessage="Free access to world class education" />
          </Title>
          <Desc>
            <FormattedMessage defaultMessage="Unlock your full potential with free access to world-class education, designed just for you. Learn at your own pace, anytime, anywhere, whether you're on the go or behind the chair." />
          </Desc>
        </AccessSectionHeader>
        <AccessSectionGrid>
          {academy.map(({ title, link, linkLabel, imageSrc }, idx) => (
            <Card
              key={idx}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={imageSrc} alt={title} />
              <CardTitle>{title}</CardTitle>
              <Button>{linkLabel}</Button>
            </Card>
          ))}
        </AccessSectionGrid>
      </AccessSection>

      <VideosSection>
        <Title>
          <FormattedMessage defaultMessage="Educational Videos" />
        </Title>
        <VideosGrid>
          {educationalVideos.map(({ title, link, imageSrc }, idx) => (
            <Card
              key={idx}
              className="--video"
              href={link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={imageSrc} alt={title} />
              <CardTitle>{title}</CardTitle>
            </Card>
          ))}
        </VideosGrid>
      </VideosSection>

      <EducationBlock excludePage="education-on-demand" />
    </Root>
  );
};
